import { ReadonlyVec2 } from 'gl-matrix';
import { PanZoom } from '../../view/PanZoom';
import { ModifierKeys } from '../ModifierKeys';
import { Tool } from '../Tool';
import { PanAction } from '../actions/PanAction';
import { ZoomAction } from '../actions/ZoomAction';
import { View } from '~/engine/view/View';
import { EventHandlerResult } from '../EventHandlerResult';
import { PlaneView } from '~/engine/view/views/PlaneView';

/**
 * {@link PanTool} is a {@link Tool} that provides default {@link PanAction Panning} and {@link ZoomAction Zooming} functionality.\
 * {@link PanAction} is bound to mouse left click without any {@link ModifierKeys}.\
 * {@link ZoomAction} is bound to wheel with {@link ModifierKeys.CTRL CTRL} as a {@link ModifierKeys ModifierKey}.
 */
export class PanTool extends Tool {
    public readonly toolType = 'pan';
    public constructor(panZoom: PanZoom) {
        super();
        this._panAction = new PanAction(panZoom, 0);
        this._zoomAction = new ZoomAction(panZoom, ModifierKeys.CTRL);
    }

    private readonly _panAction: PanAction;
    private readonly _zoomAction: ZoomAction;

    public onMousePress(
        button: number,
        modifierKeys: ModifierKeys,
        coordinates: ReadonlyVec2,
        view: View
    ): EventHandlerResult {
        return this._panAction.onMousePress(
            button,
            modifierKeys,
            coordinates,
            view
        );
    }

    public onMouseMove(
        coordinates: ReadonlyVec2,
        buttons: number,
        view: View
    ): EventHandlerResult {
        return this._panAction.onMouseMove(coordinates, buttons, view);
    }

    public onMouseRelease(
        button: number,
        coordinates: ReadonlyVec2,
        _view: View
    ): EventHandlerResult {
        return this._panAction.onMouseRelease(button, coordinates);
    }

    public onMouseWheel(
        delta: 1 | -1,
        modifierKeys: ModifierKeys,
        coordinates: ReadonlyVec2,
        view: PlaneView
    ): EventHandlerResult {
        return this._zoomAction.onMouseWheel(
            delta,
            modifierKeys,
            coordinates,
            view
        );
    }
}
